<template>
    <ui-PanelOverlay panel="config" :id="`componet_${_uid}`" :show="show" :loading="loading">
        <template v-slot:menuBar>
            <PanelMixinBack></PanelMixinBack>
        </template>
        <template v-slot:body>
            <ui-RichMenu :name="$dicc.addInstallationPanel.addNew" :navigation="true">
                <template v-slot:options>
                    <FormMixinInput
                        type="hidden"
                        :label="$dicc.addInstallationPanel.typeInstallation"
                        property="reference"
                    ></FormMixinInput>
                    <FormMixinInput
                        type="text"
                        :label="$dicc.addInstallationPanel.referenceInstallation"
                        property="reference"
                    ></FormMixinInput>
                    <FormMixinInput
                        type="text"
                        :label="$dicc.addInstallationPanel.nameInstallation"
                        property="name"
                    ></FormMixinInput>
                    <div class="richMenu__actions">
                        <a class="btn btn--simple" @click="doAddInstallation">{{ $dicc.confirm }}</a>
                    </div>
                </template>
            </ui-RichMenu>
        </template>
    </ui-PanelOverlay>
</template>

<script>
    // :class="{ modeHeat: device.status.m != '0' }" class="fulldevice"
    import { PanelMixin } from '../mixins/PanelMixin';
    import { MqttMixin } from '../mixins/MqttMixin';
    import { FormMixin } from '../mixins/FormMixin';

    export default {
        name: 'AddInstallationPanel',
        mixins: [PanelMixin, MqttMixin, FormMixin],
        inject: ['view'],
        props: {
            show: Boolean,
            location: Object,
        },
        data: function() {
            return {
                type: 'intallation',
            };
        },
        methods: {
            init() {
                this.$set(this, 'model', {
                    name: '',
                    reference: '',
                    type: 'ZONE',
                });
            },

            doAddInstallation: function() {
                this.loading++;
                this.resetErrors();

                this.syncInstallation(
                    this.installation,
                    (data) => {
                        this.$toast({
                            message: this.$dicc.addInstallationPanel.added,
                            container: `#componet_${this.view._uid}`,
                            type: 'is-success',
                        });
                        this.$api.refreshAwsCredentials((data) => this.$session.setAwsCredential(data.entity));
                        this.$nextTick(() => {
                            this.$emit('update:show', false);
                            this.$emit('addedInstallation', false);
                        });
                    },
                    (error) => {
                        dd(error);
                        this.$toast({
                            message: this.$dicc.addInstallationPanel.error,
                            container: `#componet_${this._uid}`,
                            type: 'is-danger',
                        });
                    },
                    () => this.loading--
                );
            },
        },
        watch: {
            show: {
                immediate: true,
                handler(val) {
                    if (val) this.init();
                },
            },
        },
        computed: {
            installation() {
                return {
                    version: 1,
                    location_id: this.location.id,
                    name: this.model.name,
                    reference: this.model.reference,
                    type: this.model.type,
                };
            },
        },
    };
</script>
